import { Group } from "./group.component.js";

class Widget extends Group {
  namespace = "visual:widget";
}

const widget = new Widget();
export { Widget, widget };
